export const TITLEBAR_HEIGHT = 56;
export const CONTAINER_WIDTH = 375;
